import { render } from "./LeaderboardModal.vue?vue&type=template&id=4d285952&scoped=true"
import script from "./LeaderboardModal.vue?vue&type=script&lang=js"
export * from "./LeaderboardModal.vue?vue&type=script&lang=js"

import "./LeaderboardModal.vue?vue&type=style&index=0&id=4d285952&scoped=true&lang=css"

import exportComponent from "C:\\Assembla\\VIV0006\\root\\dev\\QuizWhiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d285952"]])

export default __exports__